/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplaceTeamRequest
 */
export interface ReplaceTeamRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ReplaceTeamRequest
     */
    readonly $schema?: string;
    /**
     * Team Basket API ID
     * @type {number}
     * @memberof ReplaceTeamRequest
     */
    basketApiId: number;
    /**
     * Team CBBD API ID
     * @type {number}
     * @memberof ReplaceTeamRequest
     */
    cbbdApiId: number;
    /**
     * Team ESPN ID
     * @type {number}
     * @memberof ReplaceTeamRequest
     */
    espnId: number;
    /**
     * Team external URL, link to their athletics website
     * @type {string}
     * @memberof ReplaceTeamRequest
     */
    externalUrl: string;
    /**
     * Name of the season
     * @type {string}
     * @memberof ReplaceTeamRequest
     */
    name: string;
    /**
     * Team NCAA SEO
     * @type {string}
     * @memberof ReplaceTeamRequest
     */
    ncaaSeo: string;
    /**
     * Team primary color
     * @type {string}
     * @memberof ReplaceTeamRequest
     */
    primaryColor: string;
    /**
     * Team secondary color
     * @type {string}
     * @memberof ReplaceTeamRequest
     */
    secondaryColor: string;
    /**
     * Team short name
     * @type {string}
     * @memberof ReplaceTeamRequest
     */
    shortName: string;
}

/**
 * Check if a given object implements the ReplaceTeamRequest interface.
 */
export function instanceOfReplaceTeamRequest(value: object): value is ReplaceTeamRequest {
    if (!('basketApiId' in value) || value['basketApiId'] === undefined) return false;
    if (!('cbbdApiId' in value) || value['cbbdApiId'] === undefined) return false;
    if (!('espnId' in value) || value['espnId'] === undefined) return false;
    if (!('externalUrl' in value) || value['externalUrl'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ncaaSeo' in value) || value['ncaaSeo'] === undefined) return false;
    if (!('primaryColor' in value) || value['primaryColor'] === undefined) return false;
    if (!('secondaryColor' in value) || value['secondaryColor'] === undefined) return false;
    if (!('shortName' in value) || value['shortName'] === undefined) return false;
    return true;
}

export function ReplaceTeamRequestFromJSON(json: any): ReplaceTeamRequest {
    return ReplaceTeamRequestFromJSONTyped(json, false);
}

export function ReplaceTeamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceTeamRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'basketApiId': json['basket_api_id'],
        'cbbdApiId': json['cbbd_api_id'],
        'espnId': json['espn_id'],
        'externalUrl': json['external_url'],
        'name': json['name'],
        'ncaaSeo': json['ncaa_seo'],
        'primaryColor': json['primary_color'],
        'secondaryColor': json['secondary_color'],
        'shortName': json['short_name'],
    };
}

export function ReplaceTeamRequestToJSON(json: any): ReplaceTeamRequest {
    return ReplaceTeamRequestToJSONTyped(json, false);
}

export function ReplaceTeamRequestToJSONTyped(value?: Omit<ReplaceTeamRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'basket_api_id': value['basketApiId'],
        'cbbd_api_id': value['cbbdApiId'],
        'espn_id': value['espnId'],
        'external_url': value['externalUrl'],
        'name': value['name'],
        'ncaa_seo': value['ncaaSeo'],
        'primary_color': value['primaryColor'],
        'secondary_color': value['secondaryColor'],
        'short_name': value['shortName'],
    };
}

